import React from 'react';
import { Field } from 'formik';
import { Divider, Typography, IconButton } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { AutoCompleteSelectUI, CheckboxUI, FormErrorUI, FormLabelUI, InputUI } from '../Interface';
import useParam from '../../context/ParamContext';

const CompanyCustomerFields = ({
  viewField,
  values,
  errors,
  setFieldValue,
  validateField,
  autocompleteOptions,
  customerVatCode,
  salesPerson,
  setSalesPersonDialogOpen,
  addField,
  selectedValues,
}) => {
  const { params } = useParam();
  const currentSalesPerson = selectedValues.companySalesPerson?.[0]?.salesPerson?.name ?? null;

  return (
    <>
      <div className="grid grid-cols-4 gap-x-4 gap-y-3 mx-4 mb-5">
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="customerPriceListId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Árlista" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.customerPriceListId} />}
            onChange={(_e, newVal) => {
              setFieldValue('customerPriceListId', newVal?.value ?? null).then(() => {
                validateField('customerPriceListId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.customerPriceListId !== '' }}
            selectedValue={values.customerPriceListId}
            dataset={autocompleteOptions.priceList}
            isOptionEqualToValue={(option, value) => option.value === value}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="customerPaymentMethodId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Fizetési mód" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.customerPaymentMethodId} />}
            onChange={(_e, newVal) => {
              setFieldValue('customerPaymentMethodId', newVal?.value ?? null).then(() => {
                validateField('customerPaymentMethodId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.customerPaymentMethodId !== '' }}
            selectedValue={values.customerPaymentMethodId}
            dataset={autocompleteOptions.paymentMethod}
            isOptionEqualToValue={(option, value) => option.value === value}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="customerCurrencyCode"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Pénznem" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.customerCurrencyCode} />}
            onChange={(_e, newVal) => {
              setFieldValue('customerCurrencyCode', newVal?.value ?? null).then(() => {
                validateField('customerCurrencyCode');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.customerCurrencyCode !== '' }}
            selectedValue={values.customerCurrencyCode}
            dataset={autocompleteOptions.currency}
            isOptionEqualToValue={(option, value) => option.value === value}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="customerVatCode"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Áfakulcs" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.customerVatCode} />}
            onChange={(_e, newVal) => {
              setFieldValue('customerVatCode', newVal?.value ?? null).then(() => {
                validateField('customerVatCode');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.customerVatCode !== '' }}
            selectedValue={values.customerVatCode}
            dataset={customerVatCode}
            isOptionEqualToValue={(option, value) => option.value === value}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="customerDeliveryMethodId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Szállítási mód" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.customerDeliveryMethodId} />}
            onChange={(_e, newVal) => {
              setFieldValue('customerDeliveryMethodId', newVal?.value ?? null).then(() => {
                validateField('customerDeliveryMethodId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.customerDeliveryMethodId !== '' }}
            selectedValue={values.customerDeliveryMethodId}
            dataset={autocompleteOptions.deliveryMethod}
            isOptionEqualToValue={(option, value) => option.value === value}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="customerIncotermCode"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Fuvarparitás" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.customerIncotermCode} />}
            onChange={(_e, newVal) => {
              setFieldValue('customerIncotermCode', newVal?.value ?? null).then(() => {
                validateField('customerIncotermCode');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.customerIncotermCode !== '' }}
            selectedValue={values.customerIncotermCode}
            dataset={autocompleteOptions.incoterm}
            isOptionEqualToValue={(option, value) => option.value === value}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="text"
            name="incotermCity"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Város" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.incotermCity} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.incotermCity && values.incotermCity !== '' }}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="salesPersonId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Értékesítő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.salesPersonId} />}
            onChange={(_e, newVal) => {
              setFieldValue('salesPersonId', newVal?.value ?? null).then(() => {
                validateField('salesPersonId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.salesPersonId !== '' }}
            selectedValue={values.salesPersonId}
            dataset={salesPerson}
            isOptionEqualToValue={(option, value) => option.value === value}
          />
        </div>
      </div>
      {params.SHOW_COMPANY_SALES_PERSON_PERIOD_FIELD === 'Y' && (
        <>
          <Divider />
          <div className="flex items-center gap-2 mt-2">
            <div>
              <Typography variant="body2" color="text.secondary">
                Értékesítő
              </Typography>

              <Typography variant="body1" color={currentSalesPerson ? 'text.primary' : 'error.main'}>
                {currentSalesPerson ?? 'Nincs érvényes értékesítő!'}
              </Typography>
            </div>
            <IconButton
              size="small"
              onClick={() => {
                setSalesPersonDialogOpen(true);
              }}
              disabled={viewField || !addField}
            >
              <EditOutlinedIcon />
            </IconButton>
          </div>
        </>
      )}
      <div className="grid grid-cols-4 gap-x-4 mt-4">
        <div className="col-span-4">
          <CheckboxUI
            label="E-számla"
            checked={values.electronicInvoiceEnabled ?? false}
            onCheckedChange={(checked) => setFieldValue('electronicInvoiceEnabled', checked)}
            disabled={viewField}
          />
        </div>
        <div className="col-span-4">
          <Field
            name="electronicInvoiceEmail"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="E-számla e-mail-cím" />}
            variant="standard"
            disabled={viewField}
            helperText={
              <FormErrorUI
                message={errors.electronicInvoiceEmail || 'Több e-mail-cím pontosvesszővel választható el.'}
              />
            }
            InputLabelProps={{ shrink: Boolean(values.electronicInvoiceEmail) }}
          />
        </div>
      </div>
    </>
  );
};

export default CompanyCustomerFields;
